export enum WIDGET_SITE_LIST {
    /**
     * @value Add the site %NAME% to my favorite sites
     * @description Accessible label of the favorite button in the site list widget. %NAME% is the site name. Replaces WIDGET_SITE_LIST.ADD_TO_MY_SITES for a11y (WCAG 2.5.3, SUP-9270).
     */
    ADD_SITE_TO_MY_SITES = 'WIDGET_SITE_LIST.ADD_SITE_TO_MY_SITES',
    /**
     * @value Add to my favorite sites
     * @description This tooltip is used by the favorite button directive when used inside of an instance block (used in the instance list widget)
     */
    ADD_TO_MY_SITES = 'WIDGET_SITE_LIST.ADD_TO_MY_SITES',
    /**
     * @value Remove from my favorite sites
     * @description This tooltip is used by the favorite button directive when used inside of an instance block (used in the instance list widget)
     */
    REMOVE_FROM_MY_SITES = 'WIDGET_SITE_LIST.REMOVE_FROM_MY_SITES',
    /**
     * @value Remove the site %NAME% from my favorite sites
     * @description Accessible label of the favorite button in the site list widget. %NAME% is the site name. Replaces WIDGET_SITE_LIST.REMOVE_FROM_MY_SITES for a11y (WCAG 2.5.3, SUP-9270).
     */
    REMOVE_SITE_FROM_MY_SITES = 'WIDGET_SITE_LIST.REMOVE_SITE_FROM_MY_SITES',
    /**
     * @value Favorite successfully added
     */
    USER_FAVORITES_ADD = 'WIDGET_SITE_LIST.USER_FAVORITES_ADD',
    /**
     * @value Favorite successfully deleted
     */
    USER_FAVORITES_DELETE = 'WIDGET_SITE_LIST.USER_FAVORITES_DELETE',
}
